import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FtrLogoComponent } from '~app/core/logo/ftr/ftr-logo.component'
import { ThemedLogoPathPipe } from '~app/core/logo/ftr/themed-logo-path.pipe'

@NgModule({
  imports: [RouterModule],
  declarations: [FtrLogoComponent, ThemedLogoPathPipe],
  exports: [FtrLogoComponent],
})
export class FtrLogoModule {}
